import { styled as styledMui, Box } from "@mui/material";

export const CardContainer = styledMui(Box)<{ active?: string }>(
  ({ theme, active }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    padding: "14px 16px",
    borderRadius: "12px",
    cursor: "pointer",
    backgroundColor:
      active === "true"
        ? theme.palette.action.hover
        : theme.palette.action.disabledBackground ||
          "rgba(255, 255, 255, 0.04)",
    border:
      active === "true"
        ? `1.5px solid ${theme.palette.primary.main}`
        : "1.5px solid transparent",
    transition: "all 0.25s ease-in-out",
    position: "relative",
    overflow: "hidden",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      borderColor:
        active === "true" ? theme.palette.primary.main : theme.palette.divider,
      "& .sidebar-card-action-row": {
        maxHeight: "48px",
        opacity: 1,
        marginTop: "8px",
      },
    },
    "&.disabled": {
      opacity: 0.35,
      cursor: "not-allowed",
      pointerEvents: "none",
    },
  }),
);

export const CardTopRow = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  width: "100%",
});

export const CardIconWrapper = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: "20px",
  height: "20px",
  color: theme.palette.text.primary,
}));

export const ActionRow = styledMui(Box)({
  maxHeight: 0,
  opacity: 0,
  overflow: "hidden",
  transition: "all 0.25s ease-in-out",
  marginTop: 0,
  display: "flex",
  justifyContent: "flex-end",
});

export const ChildrenContainer = styledMui(Box)({
  overflow: "hidden",
  transition: "all 0.25s ease-in-out",
  display: "flex",
  flexDirection: "column",
  gap: "2px",
});

export const ChildItem = styledMui(Box)(({ theme }) => ({
  padding: "6px 8px 6px 30px",
  borderRadius: "6px",
  cursor: "pointer",
  transition: "background-color 0.15s ease",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const CardDivider = styledMui(Box)(({ theme }) => ({
  height: "1px",
  backgroundColor: theme.palette.divider,
  margin: "8px 0",
}));
